import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c57e8cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TUIChat-header TUIChat-header-new" }
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = { class: "TUIChat-main" }
const _hoisted_4 = ["id"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-bottom-double" }, null, -1))
const _hoisted_6 = { class: "to-bottom-tip-cont" }
const _hoisted_7 = {
  key: 0,
  class: "dialog dialog-conversation"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "name" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "name"
}
const _hoisted_12 = { class: "dialog dialog-conversation" }
const _hoisted_13 = {
  class: "func",
  id: "func"
}
const _hoisted_14 = { class: "func-main" }
const _hoisted_15 = { class: "mask-main" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "TUIChat"
}
const _hoisted_18 = { class: "TUIChat-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypingHeader = _resolveComponent("TypingHeader")!
  const _component_Manage = _resolveComponent("Manage")!
  const _component_Replies = _resolveComponent("Replies")!
  const _component_MessageTimestamp = _resolveComponent("MessageTimestamp")!
  const _component_MessageItem = _resolveComponent("MessageItem")!
  const _component_ReadReceiptDialog = _resolveComponent("ReadReceiptDialog")!
  const _component_imagePreviewer = _resolveComponent("imagePreviewer")!
  const _component_MessageInput = _resolveComponent("MessageInput")!
  const _component_MessageSystem = _resolveComponent("MessageSystem")!

  return (_ctx.conversationType === 'chat')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["TUIChat", [_ctx.env.isH5 ? 'TUIChat-H5' : '']])
      }, [
        _createElementVNode("header", _hoisted_1, [
          (_ctx.env.isH5)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon icon-back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_TypingHeader, {
            needTyping: _ctx.needTyping,
            conversation: _ctx.conversation,
            messageList: _ctx.messageList,
            ref: "typingRef"
          }, null, 8, ["needTyping", "conversation", "messageList"]),
          _createElementVNode("aside", _hoisted_2, [
            (_ctx.conversation.groupProfile)
              ? (_openBlock(), _createBlock(_component_Manage, {
                  key: 0,
                  conversation: _ctx.conversation,
                  userInfo: _ctx.userInfo,
                  isH5: _ctx.env.isH5
                }, null, 8, ["conversation", "userInfo", "isH5"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Replies, {
              message: _ctx.currentMessage,
              conversation: _ctx.conversation,
              show: _ctx.repliesDialogStatus,
              isH5: _ctx.env.isH5,
              messageList: _ctx.messageList,
              onCloseDialog: _ctx.closeDialog,
              ref: "repliesDialog"
            }, null, 8, ["message", "conversation", "show", "isH5", "messageList", "onCloseDialog"])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", {
            class: "TUI-message-list",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogID = '')),
            ref: "messageEle",
            id: "messageEle"
          }, [
            (!_ctx.isCompleted)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "message-more",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getHistoryMessageList && _ctx.getHistoryMessageList(...args)))
                }, _toDisplayString(_ctx.$t("TUIChat.查看更多")), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                id: item?.ID,
                ref_for: true,
                ref: "messageAimID"
              }, [
                _createVNode(_component_MessageTimestamp, {
                  currTime: item?.time,
                  prevTime: index > 0 ? _ctx.messages[index - 1]?.time : 0
                }, null, 8, ["currTime", "prevTime"]),
                _createVNode(_component_MessageItem, {
                  message: item,
                  env: _ctx.env,
                  types: _ctx.types,
                  displayGroupMessageReadReceipt: _ctx.needGroupReceipt,
                  displayEmojiReactions: _ctx.isNeedEmojiReact,
                  messageList: _ctx.messages,
                  onHandleEditor: _ctx.handleEditor,
                  onShowDialog: _ctx.showDialog,
                  onUploading: _ctx.handleUploadingImageOrVideo,
                  onJumpID: _ctx.jumpID,
                  onResendMessage: _ctx.resendMessage
                }, null, 8, ["message", "env", "types", "displayGroupMessageReadReceipt", "displayEmojiReactions", "messageList", "onHandleEditor", "onShowDialog", "onUploading", "onJumpID", "onResendMessage"])
              ], 8, _hoisted_4))
            }), 128)),
            (_ctx.needToBottom)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "to-bottom-tip",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToTarget('bottom')))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.toBottomTipCont), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512),
          (_ctx.forwardStatus && _ctx.messageComponents.Forward)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(), _createBlock(_resolveDynamicComponent('Forward'), {
                  list: _ctx.conversationData.list,
                  message: _ctx.currentMessage,
                  show: _ctx.forwardStatus,
                  isH5: _ctx.env.isH5,
                  "onUpdate:show": _cache[4] || (_cache[4] = (e) => (_ctx.forwardStatus = e))
                }, {
                  left: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.conversationData.handleAvatar(data)
                    }, null, 8, _hoisted_8),
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.conversationData.handleName(data)), 1)
                  ]),
                  right: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.conversationData.handleAvatar(data)
                    }, null, 8, _hoisted_10),
                    (!_ctx.env.isH5)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_11, _toDisplayString(_ctx.conversationData.handleName(data)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 40, ["list", "message", "show", "isH5"]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ReadReceiptDialog, {
              message: _ctx.currentMessage,
              conversation: _ctx.conversation,
              show: _ctx.receiptDialogStatus,
              isH5: _ctx.env.isH5,
              onCloseDialog: _ctx.closeDialog,
              ref: "readReceiptDialog"
            }, null, 8, ["message", "conversation", "show", "isH5", "onCloseDialog"])
          ]),
          (_ctx.showImagePreview)
            ? (_openBlock(), _createBlock(_component_imagePreviewer, {
                key: 1,
                currentImage: _ctx.currentImagePreview,
                imageList: _ctx.imageList,
                onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showImagePreview = false))
              }, null, 8, ["currentImage", "imageList"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["TUIChat-footer", [_ctx.isMute && 'disabled', _ctx.env.isH5 && 'TUIChat-H5-footer']])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("main", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pluginComponentList, (item, index) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
                  key: index,
                  isMute: _ctx.isMute,
                  isH5: _ctx.env.isH5,
                  conversation: _ctx.conversation,
                  parentID: "func",
                  onSend: _ctx.handleSend
                }, null, 40, ["isMute", "isH5", "conversation", "onSend"]))
              }), 128))
            ])
          ]),
          _createVNode(_component_MessageInput, {
            ref: "messageInput",
            conversation: _ctx.conversation,
            memberList: _ctx.allMemberList,
            env: _ctx.env,
            isGroup: _ctx.userInfo?.isGroup,
            replyOrReference: _ctx.reference,
            isMute: _ctx.isMute,
            muteText: _ctx.muteText,
            placeholder: _ctx.$t('TUIChat.请输入消息'),
            onSendMessage: _ctx.reportMessageSend,
            onResetReplyOrReference: _ctx.resetReplyOrReference,
            onOnTyping: _ctx.handleTyping
          }, null, 8, ["conversation", "memberList", "env", "isGroup", "replyOrReference", "isMute", "muteText", "placeholder", "onSendMessage", "onResetReplyOrReference", "onOnTyping"])
        ], 2),
        _withDirectives(_createElementVNode("div", {
          class: "mask",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showResend = false))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("header", null, _toDisplayString(_ctx.$t("TUIChat.确认重发该消息？")), 1),
            _createElementVNode("footer", null, [
              _createElementVNode("p", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showResend = false))
              }, _toDisplayString(_ctx.$t("TUIChat.取消")), 1),
              _hoisted_16,
              _createElementVNode("p", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, _toDisplayString(_ctx.$t("TUIChat.确定")), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showResend]
        ])
      ], 2))
    : (_ctx.conversationType === 'system')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("header", _hoisted_18, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.conversationName), 1)
          ]),
          _createVNode(_component_MessageSystem, {
            data: _ctx.messages,
            types: _ctx.types,
            onApplication: _ctx.handleApplication
          }, null, 8, ["data", "types", "onApplication"])
        ]))
      : (_ctx.slotDefault)
        ? _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
        : _createCommentVNode("", true)
}